export interface APIError extends Error {
  status: number;
  statusText?: string;
}

export const isAPIError = (error: unknown): error is APIError => {
  return typeof error === 'object' && error !== null && 'status' in error;
};
